// Triggers a browser download of /api/work-orders/{id}/pdf using the
// authenticated axios instance. We can't use a plain <a href> because the
// route is JWT-protected — the auth header has to ride on the request.

export async function downloadWorkOrderPdf(api, wo) {
  if (!wo?.id) throw new Error('missing work order id');
  const res = await api.get(`/work-orders/${wo.id}/pdf`, { responseType: 'blob' });
  const blob = res.data instanceof Blob
    ? res.data
    : new Blob([res.data], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const filename = `${wo.work_order_no || wo.id || 'work-order'}.pdf`;
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Revoke after the click handler chain to avoid Safari aborting the dl.
  setTimeout(() => URL.revokeObjectURL(url), 2_000);
}
